import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import SettingsSidebar from "../SettingsSidebar";
import TopBar from "../components/ui-components/TopBar";
import { HeaderSlotProvider } from "../components/ui-components/HeaderSlot";
import "../index.css";

// Settings shell: same structure as Main (TopBar + scrolling content owning the
// vertical scroll) but with the categorized SettingsSidebar instead of the app nav.
export default function SettingsLayout() {
  return (
    <HeaderSlotProvider>
      <div className="app h-full min-h-full flex flex-row w-full min-w-full bg-bg">
        <SettingsSidebar />
        <div className="flex flex-1 w-full flex-col min-w-0 overflow-y-auto">
          <TopBar />
          <Outlet context={useOutletContext()} />
        </div>
      </div>
    </HeaderSlotProvider>
  );
}
